import { ClientEnvironment, FooterNavigation } from '@thehubz/client/core';

export const westlottoFooterConfig = (env?: ClientEnvironment): FooterNavigation[] => {
  return [
    {
      navLink: [env?.brandConfig?.navigation?.imprintUrl ?? '/content/imprint'],
      navText: $localize`:footer navigation:Imprint`,
    },
  ];
};
